module.exports = __webpack_public_path__ + "static/media/deleteIcon.cb93b680.svg";